import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/vouchers-online.svg';
import _imports_1 from '@/assets/vouchers-in-store.svg';
const _hoisted_1 = {
    key: 0,
    class: "wrapper"
};
const _hoisted_2 = { class: "header-image" };
const _hoisted_3 = { class: "header skeleton-header" };
const _hoisted_4 = { class: "cart" };
const _hoisted_5 = { class: "howto" };
const _hoisted_6 = {
    key: 0,
    class: "wrapper"
};
const _hoisted_7 = { class: "header-image" };
const _hoisted_8 = { class: "header" };
const _hoisted_9 = ["src"];
const _hoisted_10 = { class: "merchantName" };
const _hoisted_11 = { class: "percentage" };
const _hoisted_12 = {
    key: 0,
    src: _imports_0,
    class: "online-icon"
};
const _hoisted_13 = {
    key: 0,
    src: _imports_1,
    class: "in-store-icon"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = { class: "cart" };
const _hoisted_16 = {
    key: 2,
    class: "constraints small"
};
const _hoisted_17 = {
    key: 0,
    class: "howto fromBrand"
};
const _hoisted_18 = ["href"];
const _hoisted_19 = ["href"];
const _hoisted_20 = { key: 0 };
const _hoisted_21 = ["src"];
const _hoisted_22 = { class: "simplePage" };
import { ref, computed, onMounted, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import { useContent } from '@/composables/useContent';
import HeaderBlock from './elements/HeaderBlock.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import FavoriteChip from './elements/FavoriteChip.vue';
import MGButton from './elements/MGButton.vue';
import MGTextField from './elements/MGTextField.vue';
import MGSelect from './elements/MGSelect.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherAmountPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getAvailableVoucher, getCustomerVouchers, getCustomerFavouriteVouchers, addCustomerFavouriteDiscount, removeCustomerFavouriteDiscount, removeUnavailableDiscountProviders, createCart } = useVouchers();
        const { getCmsArticleByKey } = useContent();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const closedDrawerHeightNoMenu = computed(() => {
            return (60 + (cookies?.get('sb') ? parseInt(cookies.get('sb')) : 0)) + 'px';
        });
        const peekingDrawerBottomNoMenu = computed(() => {
            return '-10px';
        });
        const useCredit = ref(false);
        const amount = ref(null);
        const errorText = ref(null);
        const pay = ref(false);
        const paymentLoading = ref(false);
        const paymentResponse = ref(null);
        const paymentPending = ref(false);
        const voucherResponse = ref(null);
        const closable = ref(true);
        const showAll = ref(false);
        const guide = ref(null);
        const termsDrawer = ref(null);
        const guideDrawer = ref(null);
        const doubleDrawer = ref(null);
        function onLoad() {
            if (route.query.amount !== undefined) {
                amount.value = parseFloat(route.query.amount);
            }
            if (route.query.useSavedToSpend !== undefined) {
                useCredit.value = route.query.useSavedToSpend === 'true' || route.query.useSavedToSpend === true;
            }
            getCustomer();
            getCustomerVouchers();
            getAvailableVoucher(route.params.id, () => {
                removeUnavailableDiscountProviders(state.availableVoucher);
                getCustomerFavouriteVouchers((f) => {
                    if (state.availableVoucher && f && f.length > 0) {
                        state.availableVoucher.favourite = f.some((fav) => fav.id === state.availableVoucher.id);
                    }
                });
                getCmsArticleByKey(("VG_" + state.availableVoucher.merchant.name.replaceAll("&", '').toUpperCase()).substring(0, 10), (article) => {
                    if (article) {
                        guide.value = article;
                    }
                });
            });
        }
        function toggleDrawer() {
            termsDrawer.value.toggleDrawer();
        }
        function toggleFavourite() {
            if (state.availableVoucher.favourite) {
                removeCustomerFavouriteDiscount(state.availableVoucher, () => {
                    state.availableVoucher.favourite = false;
                });
            }
            else {
                addCustomerFavouriteDiscount(state.availableVoucher, () => {
                    state.availableVoucher.favourite = true;
                });
            }
        }
        function showDoubleBubble() {
            doubleDrawer.value.openDrawer();
        }
        function validateAmount() {
            errorText.value = null;
            if (amount.value && state.availableVoucher.upperAmount && parseFloat(String(amount.value)) > state.availableVoucher.upperAmount) {
                amount.value = state.availableVoucher.upperAmount;
                errorText.value = "Please enter an amount no more than " + state.formatter.format(state.availableVoucher.upperAmount);
            }
            if (amount.value && state.availableVoucher.lowerAmount && parseFloat(String(amount.value)) < state.availableVoucher.lowerAmount) {
                errorText.value = "Please enter an amount at least " + state.formatter.format(state.availableVoucher.lowerAmount);
            }
        }
        function calcCashback(amt) {
            if (amt && state.availableVoucher && state.availableVoucher.effectiveDiscountPercentage) {
                var cashback = amt * (state.availableVoucher.effectiveDiscountPercentage / 100);
                return state.formatter.format(cashback) + " cashback";
            }
            return "£0 cashback";
        }
        function navigateToCart() {
            errorText.value = null;
            if (amount.value == null || amount.value == 0) {
                errorText.value = "Please enter a valid amount";
                return;
            }
            if (state.availableVoucher.lowerAmount && state.availableVoucher.lowerAmount > 0 && (amount.value < state.availableVoucher.lowerAmount || amount.value > state.availableVoucher.upperAmount)) {
                errorText.value = "Please enter an amount between " + state.formatter.format(state.availableVoucher.lowerAmount) + " and " + state.formatter.format(state.availableVoucher.upperAmount);
                return;
            }
            if (state.availableVoucher.minorUnit && state.availableVoucher.minorUnit > 0.01 && (amount.value % state.availableVoucher.minorUnit != 0)) {
                errorText.value = "Please enter an amount in multiples of " + state.formatter.format(state.availableVoucher.minorUnit);
                return;
            }
            const cartData = [{
                    amount: amount.value,
                    availableVoucher: state.availableVoucher,
                    meta: { voucherId: state.availableVoucher.id },
                    timestamp: new Date().toISOString()
                }];
            createCart(cartData);
            router.push({
                path: '/VoucherCart'
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_span = _resolveComponent("v-span");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_alert = _resolveComponent("v-alert");
            const _component_v_img = _resolveComponent("v-img");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Buy Card",
                    color: "white",
                    bgcolor: "#281C3B",
                    border: "0"
                }),
                (!_unref(state).availableVoucher)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(_component_v_skeleton_loader, {
                                    type: "image",
                                    class: "skel-categoryImage"
                                }),
                                _createVNode(_component_v_row, { class: "mt-4" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { class: "v-col-9" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "heading",
                                                    class: "skel-merchantName"
                                                }),
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "text",
                                                    class: "skel-percentage"
                                                }),
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "chip",
                                                    class: "skel-chip"
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_col, { class: "v-col-3 icon-col" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_skeleton_loader, {
                                                    type: "image",
                                                    class: "skel-icon"
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    _: 1
                                })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_v_skeleton_loader, {
                                type: "heading",
                                class: "skel-cart-heading"
                            }),
                            _createVNode(_component_v_skeleton_loader, {
                                type: "image",
                                class: "skel-cart-input"
                            }),
                            _createVNode(_component_v_skeleton_loader, {
                                type: "chip",
                                class: "skel-cart-cashback"
                            }),
                            _createVNode(_component_v_skeleton_loader, {
                                type: "button",
                                class: "skel-cart-button"
                            })
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_v_skeleton_loader, {
                                type: "heading",
                                class: "skel-howto-heading"
                            }),
                            _createVNode(_component_v_skeleton_loader, { type: "paragraph" })
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVoucher)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createElementVNode("img", {
                                                    class: "categoryImage",
                                                    src: _unref(state).availableVoucher.merchant.category && _unref(state).availableVoucher.merchant.category.buttonImage
                                                        ? _unref(state).availableVoucher.merchant.category.buttonImage
                                                        : _unref(state).availableVoucher.merchant.logoUrl
                                                }, null, 8, _hoisted_9)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_v_row, { class: "mt-4" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "v-col-9" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("h1", _hoisted_10, _toDisplayString(_unref(state).availableVoucher.merchant.name), 1),
                                                        _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(state).availableVoucher.effectiveDiscountPercentage) + "% cashback", 1),
                                                        (_unref(state).availableVoucher.online)
                                                            ? (_openBlock(), _createBlock(_component_v_span, {
                                                                key: 0,
                                                                "background-color": "blue"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (_unref(state).availableVoucher.online)
                                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                                                                        : _createCommentVNode("", true),
                                                                    _cache[3] || (_cache[3] = _createTextVNode(" Online"))
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        (_unref(state).availableVoucher.inStore)
                                                            ? (_openBlock(), _createBlock(_component_v_span, {
                                                                key: 1,
                                                                size: "small",
                                                                variant: "outlined"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    (_unref(state).availableVoucher.inStore)
                                                                        ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                                                        : _createCommentVNode("", true),
                                                                    _cache[4] || (_cache[4] = _createTextVNode(" In Store"))
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        (_unref(state).availableVoucher.stackWith && _unref(state).availableVoucher.stackWith.length > 0)
                                                            ? (_openBlock(), _createBlock(_component_v_span, {
                                                                key: 2,
                                                                size: "small",
                                                                style: { "color": "var(--text-color)", "background": "linear-gradient(90deg, #E1C6C8 0%, #FCE5D4 100%)" },
                                                                onClick: showDoubleBubble,
                                                                "background-color": "blue"
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_v_icon, { icon: "mdi-circle-double" })
                                                                ]),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, { class: "v-col-3 icon-col" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            src: _unref(state).availableVoucher.cardUrl,
                                                            class: "icon"
                                                        }, null, 8, _hoisted_14),
                                                        _createVNode(FavoriteChip, {
                                                            class: "favouriteIconChip",
                                                            transparent: true,
                                                            heartColour: 'white',
                                                            isFavorited: _unref(state).availableVoucher.favourite,
                                                            onFavoriteClicked: toggleFavourite
                                                        }, null, 8, ["isFavorited"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                    _cache[5] || (_cache[5] = _createElementVNode("h2", null, "Value you would like to purchase", -1)),
                                    (!_unref(state).availableVoucher.allowedAmounts)
                                        ? (_openBlock(), _createBlock(MGTextField, {
                                            key: 0,
                                            modelValue: amount.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((amount).value = $event)),
                                            type: "text",
                                            inputmode: "decimal",
                                            prefix: "£",
                                            label: "Enter amount",
                                            variant: "solo",
                                            flat: true,
                                            clearable: "",
                                            "single-line": "",
                                            "bg-color": "white",
                                            onInput: validateAmount,
                                            max: _unref(state).availableVoucher.upperAmount
                                        }, null, 8, ["modelValue", "max"]))
                                        : _createCommentVNode("", true),
                                    (_unref(state).availableVoucher.allowedAmounts)
                                        ? (_openBlock(), _createBlock(MGSelect, {
                                            key: 1,
                                            modelValue: amount.value,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((amount).value = $event)),
                                            prefix: "£",
                                            items: _unref(state).availableVoucher.allowedAmounts.split(',').map(Number),
                                            label: "Select amount",
                                            variant: "solo",
                                            flat: true,
                                            clearable: "",
                                            "single-line": "",
                                            "bg-color": "white"
                                        }, null, 8, ["modelValue", "items"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_v_span, {
                                        class: _normalizeClass(['cashback', { 'cashback-zero': !amount.value || amount.value <= 0 }])
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(calcCashback(amount.value)), 1)
                                        ]),
                                        _: 1
                                    }, 8, ["class"]),
                                    (_unref(state).availableVoucher.lowerAmount && _unref(state).availableVoucher.lowerAmount > 0)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, " Minimum " + _toDisplayString(_unref(state).formatter.format(_unref(state).availableVoucher.lowerAmount)) + ". Maximum " + _toDisplayString(_unref(state).formatter.format(_unref(state).availableVoucher.upperAmount)) + ". " + _toDisplayString(_unref(state).availableVoucher.minorUnit && _unref(state).availableVoucher.minorUnit > 0 ? 'Increments of ' + _unref(state).formatter.format(_unref(state).availableVoucher.minorUnit) : '') + ". ", 1))
                                        : _createCommentVNode("", true),
                                    _createVNode(MGButton, {
                                        onClick: _cache[2] || (_cache[2] = ($event) => (navigateToCart())),
                                        text: "Buy now",
                                        fullWidth: true,
                                        style: { "margin-top": "32px" }
                                    }),
                                    (errorText.value)
                                        ? (_openBlock(), _createBlock(_component_v_alert, {
                                            key: 3,
                                            class: "mt-4",
                                            density: "compact",
                                            type: "info",
                                            variant: "outlined",
                                            text: errorText.value
                                        }, null, 8, ["text"]))
                                        : _createCommentVNode("", true),
                                    _createVNode(_component_v_img, {
                                        class: "paymentMethods",
                                        src: require('@/assets/payment-methods.png')
                                    }, null, 8, ["src"])
                                ]),
                                (_unref(state).availableVoucher.redemptionInstructionsUrl || _unref(state).availableVoucher.faqUrl || _unref(state).availableVoucher.terms)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                        _createElementVNode("h2", null, "From " + _toDisplayString(_unref(state).availableVoucher.merchant.name), 1),
                                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mt-8" }, null, -1)),
                                        (_unref(state).availableVoucher.terms)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                                onClick: toggleDrawer,
                                                                class: "small"
                                                            }, [
                                                                _createVNode(_component_v_icon, { icon: "mdi-information-outline" }),
                                                                _cache[6] || (_cache[6] = _createTextVNode(" View Terms and Conditions"))
                                                            ])
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        (_unref(state).availableVoucher.faqUrl)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                                href: _unref(state).availableVoucher.faqUrl
                                                            }, [
                                                                _createVNode(_component_v_icon, { icon: "mdi-link" }),
                                                                _cache[7] || (_cache[7] = _createTextVNode(" View Brand's FAQ"))
                                                            ], 8, _hoisted_18)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true),
                                        (_unref(state).availableVoucher.redemptionInstructionsUrl)
                                            ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, null, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("a", {
                                                                href: _unref(state).availableVoucher.redemptionInstructionsUrl
                                                            }, [
                                                                _createVNode(_component_v_icon, { icon: "mdi-link" }),
                                                                _cache[8] || (_cache[8] = _createTextVNode(" View Brand's Instructions"))
                                                            ], 8, _hoisted_19)
                                                        ]),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 1
                                            }))
                                            : _createCommentVNode("", true)
                                    ]))
                                    : _createCommentVNode("", true),
                                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "howto" }, [
                                    _createElementVNode("h2", null, "How it works"),
                                    _createElementVNode("ul", null, [
                                        _createElementVNode("li", null, "Enter the value of the voucher you would like to purchase"),
                                        _createElementVNode("li", null, "Click \"Buy Now\""),
                                        _createElementVNode("li", null, "Make payment"),
                                        _createElementVNode("li", null, "Your voucher will be added to your account"),
                                        _createElementVNode("li", null, "Some retail cards need to be \"claimed\" before they can be used. Follow the on screen instructions")
                                    ]),
                                    _createElementVNode("p", { class: "mt-3" }, "* A small Stripe transaction processing fee is added to the purchase price. This allows us to provide you with the full cashback amount without any deductions later.")
                                ], -1))
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(DrawerPanel, {
                    ref_key: "termsDrawer",
                    ref: termsDrawer,
                    openHeight: "70%",
                    bottom: "-10px",
                    closedHeight: "0",
                    title: "Terms and Conditions",
                    backgroundColor: "white",
                    openBackgroundColor: "white"
                }, {
                    default: _withCtx(() => [
                        (_unref(state).availableVoucher)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_unref(state).availableVoucher.terms), 1))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }, 512),
                (guide.value)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 1,
                        ref_key: "guideDrawer",
                        ref: guideDrawer,
                        openHeight: "88%",
                        closedHeight: closedDrawerHeightNoMenu.value,
                        backgroundColor: "white",
                        bottom: peekingDrawerBottomNoMenu.value,
                        title: "How To Use Guide",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("iframe", {
                                src: '/#/articles/' + guide.value.id,
                                style: { "border": "0px", "width": "100%", "height": "100%" }
                            }, null, 8, _hoisted_21)
                        ]),
                        _: 1
                    }, 8, ["closedHeight", "bottom"]))
                    : _createCommentVNode("", true),
                (_unref(state).availableVoucher && _unref(state).availableVoucher.stackWith && _unref(state).availableVoucher.stackWith.length > 0)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 2,
                        ref_key: "doubleDrawer",
                        ref: doubleDrawer,
                        openHeight: "70%",
                        bottom: "-10px",
                        closedHeight: "0",
                        title: "What is Double Bubble?",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_22, [
                                _cache[11] || (_cache[11] = _createElementVNode("h1", null, "Double Bubble?", -1)),
                                _createVNode(_component_v_icon, {
                                    icon: "mdi-circle-double",
                                    class: "heroImg"
                                }),
                                _cache[12] || (_cache[12] = _createElementVNode("p", null, "Double Bubble allows you to combine a Money Guided cashback voucher with another discount at point of sale to double down on your savings!", -1)),
                                _createElementVNode("p", null, "For example, at " + _toDisplayString(_unref(state).availableVoucher.merchant.name) + ", you may be able to use your " + _toDisplayString(_unref(state).availableVoucher.stackWith[0]) + " at point of sale and get a discount on your final bill, then use a Money Guided cashback voucher to pay, saving you a lot more!", 1),
                                _createElementVNode("p", null, "Check your " + _toDisplayString(_unref(state).availableVoucher.stackWith[0]) + " to see what you can combine with Money Guided vouchers at " + _toDisplayString(_unref(state).availableVoucher.merchant.name) + ".", 1),
                                _cache[13] || (_cache[13] = _createElementVNode("p", null, [
                                    _createElementVNode("small", null, "While we try our best to highlight potential opportunities for Double Bubble, your mileage may vary.")
                                ], -1))
                            ])
                        ]),
                        _: 1
                    }, 512))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
